import styled from 'styled-components'

export const StoreIcon = styled.img`
	height: 40px;
	display: block;
	width: auto !important;
`
